import http from "./http";

/* =========================
   GET ALL USERS REPORT
   (No filters)
========================= */
export const getUsersReport = async () => {
  try {
    const res = await http.get("/users_report");
    return res.data;
  } catch (error) {
    console.error("Get Users Report Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY ROLE
   role = "sales" | "tm"
========================= */
export const getUsersByRole = async (role) => {
  try {
    const res = await http.get("/users_report", {
      params: { role },
    });
    return res.data;
  } catch (error) {
    console.error("Get Users By Role Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY DATE RANGE
   from = "YYYY-MM-DD"
   to   = "YYYY-MM-DD"
========================= */
export const getUsersByDate = async (from, to) => {
  try {
    const res = await http.get("/users_report", {
      params: { from, to },
    });
    return res.data;
  } catch (error) {
    console.error("Get Users By Date Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY ROLE + DATE
========================= */
export const getUsersByRoleAndDate = async (role, from, to) => {
  try {
    const res = await http.get("/users_report", {
      params: { role, from, to },
    });
    return res.data;
  } catch (error) {
    console.error("Get Users By Role & Date Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   GENERIC FUNCTION (BEST 🔥)
   Flexible use anywhere
========================= */
export const getUsersReportWithParams = async (params = {}) => {
  try {
    const res = await http.get("/users_report", { params });
    return res.data;
  } catch (error) {
    console.error("Get Users Report (Custom) Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};